import {SET_BET_HISTORY_FILTERS, RESET_BET_HISTORY_FILTERS} from "../actions/actionTypes/";
import {predefinedDateRanges} from "../constants/balanceHistory";
let initial = {
    from_date: predefinedDateRanges[0].fromDate,
    to_date: predefinedDateRanges[0].toDate,
    id: predefinedDateRanges[0].id,
    range: "0"
};
const BetHistoryFiltersReducer = (state = initial, action = {}) => {
    switch (action.type) {
        case SET_BET_HISTORY_FILTERS: {
            const index = predefinedDateRanges.findIndex(item => item.id === action.payload);
            if (~index) {
                return {
                    from_date: predefinedDateRanges[index].fromDate,
                    to_date: predefinedDateRanges[index].toDate,
                    id: predefinedDateRanges[index].id,
                    range: "0"
                };
            }
            return { ...initial };
        }
        case RESET_BET_HISTORY_FILTERS:
            return {...initial};
        default :
            return state;
    }
};

export default BetHistoryFiltersReducer;